export function useChat() {
  const triggerChat = () => {
    if (typeof window !== 'undefined') {
      window?.LC_API?.open_chat_window()
    }
  }

  return {
    triggerChat,
  }
}
